import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import { showErrorToast } from "app/actions/toast_actions";
import { fetchWebsitesFaviconsQuery } from "app/services/sitesService/queries/sitesQueries";

const ACTIVATION_ICONS_QUERY_KEY = "activation_icons_query_key";

const useIconsMutation = () => {
    const dispatch = useDispatch();

    return useMutation({
        mutationKey: [ACTIVATION_ICONS_QUERY_KEY],
        mutationFn: (domains: string[]) => {
            return fetchWebsitesFaviconsQuery(domains);
        },
        onError: (error: Error) => {
            dispatch(showErrorToast(error?.message));
        },
    });
};

export default useIconsMutation;
